import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { VASCO_FLOW, VASCO_MODAL_TYPES } from '../../../constants';

export default () => muster()
  .path('rsa.validateToken', {
    call: async ({ req }, { get, set, call }) => {
      const { rsaTokenStatus, jwt } = req.args[0];
      // const [rsaTokenSuccess] = await getValues(get([`roster.data.rsa.validateToken.${rsaToken}`]));
      if (rsaTokenStatus == 0) {
        set('rsa.rsaVisible', false);
        set('rsa.rsaAuthorised', true);
        set('auth.authHeader', jwt);

        //set the jwt in the req header of the Falcor Model
        await getValues(get([`roster.ebanking.app.mAuth.["${jwt}"]`]));

        await set('auth.dashboardAuthorised', true);
        const [rsaPageName] = await getValues(get('ui.state.rsaPageName'));
        await call('auth.getDashboardContent');

        call('ui.history.push', { pathname: rsaPageName });
        call('ui.history.replace', { pathname: rsaPageName });
        //let rsaUrl = "/rsaredirect?jwt=" + jwt + "&url=" + rsaPageName;
        //await call('ui.history.replace', { pathname: rsaUrl });
      }
      else {
        set('rsa.rsaAuthorised', false);
      }
    },
  })
  .path('rsa.setjwt', {
    call: async ({ req }, { get, set, call }) => {
      const jwt = req.args[0];
      let [assetPositionClassname] = await getValues(get('portfolio.AssetPositionClassName'));
      
      await Promise.all([
        set('auth.authHeader', jwt),
        set('portfolio.assetClassName', assetPositionClassname)
      ]);
      //set the jwt in the req header of the Falcor Model
      if(jwt){
    await getValues(get([`roster.ebanking.app.mAuth.["${jwt}"]`]));
    }
    },
  })
  .path('rsa.changePage', {
    call: async ({ req }, { get, set, call }) => {
      const [path, clearPageHistory = false] = req.args;
      let [rsaAuthvalue] = await getValues(get('rsa.rsaAuthorised'));
      let [vascoLoginType] = await getValues(get('auth.vascoFlow'));
      let [vascoAuthvalue] = await getValues(get('vascoauthentication.vascoAuthorised'));
      set('auth.loginBusy', false);
      //console.log("##:rsaAuthorised : ", rsaAuthvalue);
      if (vascoLoginType == VASCO_FLOW.browser) {
        if (vascoAuthvalue === undefined || vascoAuthvalue === false) {
          set('vascoauthentication.vascoVisible', true);
          set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.pin2fa);
          set('ui.state.rsaPageName', path);
        }
        else {
          call('ui.history.push', { pathname: path }, clearPageHistory);
          call('vascoauthentication.hideVasco');
        }
      }
      else {
        if (rsaAuthvalue == undefined || rsaAuthvalue === false) {
          set('rsa.rsaVisible', true);
          set('ui.state.rsaPageName', path);
          //Disable 2FA for CH
          // set('rsa.rsaAuthorised', true);
          // call('ui.history.push', { pathname: path });
          // set('rsa.rsaVisible', false);
          // call('ui.history.replace', { pathname: path });
        } else {          
          await call('auth.getDashboardContent');

          call('ui.history.push', { pathname: path }, clearPageHistory);
          set('rsa.rsaVisible', false);
          call('ui.history.replace', { pathname: path });
        }
      }
    },
  })
  .path('rsa.rsaAuthorised', variable())
  .path('rsa.rsaVisible', variable(false))
  .path('rsa.rsapinVisible', variable(false))
  .path('rsa.hideRsa', {
    call: async ({ req }, { get, set, call }) => {
      try {
        set('rsa.rsaVisible', false);
      } catch (e) {
        console.log("exception ", e);
      }
    },
  })
  .path('rsa.hideRsaPin', {
    call: async ({ req }, { get, set, call }) => {
      try {
        set('rsa.rsapinVisible', false);
      } catch (e) {
        console.log("exception ", e);
      }
    },
  })
  .path('rsa.showRsaPin', {
    call: async ({ req }, { get, set, call }) => {
      try {
        set('rsa.rsapinVisible', true);
      } catch (e) {
        console.log("exception ", e);
      }
    },
  })


